import React from "react";
import { IconButton } from "@mui/material";
import {
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
} from "@mui/icons-material";

interface CollapsibleColumnButtonProps {
  isExpanded: boolean;
  onToggle: () => void;
}

/**
 * Collapsible Column Button Component
 * Wiederverwendbarer Button zum Auf-/Zuklappen von Tabellenspalten
 */
const CollapsibleColumnButton: React.FC<CollapsibleColumnButtonProps> = ({
  isExpanded,
  onToggle,
}) => {
  return (
    <IconButton
      size="small"
      onClick={(e) => {
        e.stopPropagation();
        onToggle();
      }}
      sx={{
        ml: 1,
        color: "text.secondary",
        "&:hover": {
          color: "primary.main",
        },
      }}
    >
      {isExpanded ? (
        <ChevronLeftIcon fontSize="small" />
      ) : (
        <ChevronRightIcon fontSize="small" />
      )}
    </IconButton>
  );
};

export default CollapsibleColumnButton;
